module.exports = __webpack_public_path__ + "img/4.9a1e0350.jpg";